import {Admin} from "../../data/data-class/admin/adminClass";
import {AdminLog} from "../../data/data-class/admin/adminClass";
import ViaqTryCatch from "../../services/GlobalTryCatch";
import axiosInstance from "../../services/axios";
import {Client} from "../../data/data-class/client/clientClass";

class AdminListRepository {
    static async getAdminList(text, pageNumber) {
        const data = {
            text: text.trim(),
            pagenumber: pageNumber,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/admin", data)
            });
        if (response.success) {
            const adminListObject =  response.data.admins.map(item => new Admin(item));
            const countAll = response.data.countAll;
            console.log("ADMIN : ",adminListObject)
            return {
                adminClassList: adminListObject,
                countAllPages: countAll,
                code: response.statusCode,
                massage: response.message,
            };
        }


        return {
            code: response.statusCode,
            massage: response.message,
        };
    }

    static async editAddAdmin(data) {
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/admin/change", data)
            });


        return {
            code: response.statusCode,
            massage: response.message,
        };
    }

    static async deleteAdmin(id) {
        const data = {
            id: id,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/admin/delete", data)
            });

        const code = response.statusCode;
        const massage = response.message;
        return {
            code,
            massage,
        };
    }
}

class AdminLogRepository {
    static async getLogAdmin(data) {

        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/admin/logs", data)
            });
        if (response.success) {
            const adminLogList = response.data.logs.map(
                (log) => new AdminLog(log.date, log.text)
            );
            const countAllPages = response.data.countAll;
            const name = response.data.name;
            return {
                adminLogList,
                countAllPages,
                name,
                code: response.statusCode,
                message: response.message
            };
        }
        return {
            code: response.statusCode,
            message: response.message
        }
    }
}

export {AdminListRepository};
export {AdminLogRepository};
